// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { RoleTemplate } from '../_models/role-template.model';

export enum RoleTemplateActionTypes {
  AllRoleTemplatesRequested = '[Roles Home Page] All RoleTemplates Requested',
  AllRoleTemplatesLoaded = '[Roles API] All RoleTemplates Loaded',
  RoleTemplateOnServerCreated = '[Edit RoleTemplate Dialog] RoleTemplate On Server Created',
  RoleTemplateCreated = '[Edit RoleTemplates Dialog] Roles Created',
  RoleTemplateOnServerUpdated = '[Edit RoleTemplate Dialog] RoleTemplate On Server Updated',
  RoleTemplateUpdated = '[Edit RoleTemplate Dialog] RoleTemplate Updated',
  RoleTemplateOnServerDeleted = '[RoleTemplates List Page] RoleTemplate On Server Deleted',
  RoleTemplateDeleted = '[RoleTemplates List Page] RoleTemplate Deleted',
  RoleTemplateActivated = '[RoleTemplates List Page] RoleTemplate Activated',
  RoleTemplateOnServerActivated = '[RoleTemplates List Page] RoleTemplate On Server Activated',
  RoleTemplatesOnServerDeleted = '[RoleTemplates List Page] RoleTemplates On Server Deleted',
  RoleTemplatesDeleted = '[RoleTemplates List Page] RoleTemplates Deleted',
  RoleTemplatesPageRequested = '[RoleTemplates List Page] RoleTemplates Page Requested',
  RoleTemplatesPageLoaded = '[RoleTemplates API] RoleTemplates Page Loaded',
  RoleTemplatesPageCancelled = '[RoleTemplates API] RoleTemplates Page Cancelled',
  RoleTemplatesPageToggleLoading = '[RoleTemplates page] RoleTemplates Page Toggle Loading',
  RoleTemplatesActionToggleLoading = '[RoleTemplates] RoleTemplates Action Toggle Loading',
  ThrowRoleTemplateError = '[RoleTemplates] Throw RoleTemplate Error',
  FireRoleTemplateSuccess = '[RoleTemplates] Fire Success',
}

export class RoleTemplateOnServerCreated implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateOnServerCreated;
  constructor(public payload: { roleTemplate: RoleTemplate }) {}
}

export class RoleTemplateCreated implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateCreated;
  constructor(public payload: { roleTemplate: RoleTemplate }) {}
}

export class RoleTemplateOnServerUpdated implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateOnServerUpdated;
  constructor(
    public payload: {
      partialRoleTemplate: Update<RoleTemplate>;
      roleTemplate: RoleTemplate;
    },
  ) {}
}

export class RoleTemplateUpdated implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateUpdated;
  constructor(
    public payload: {
      partialRoleTemplate: Update<RoleTemplate>;
      roleTemplate: RoleTemplate;
    },
  ) {}
}

export class RoleTemplateOnServerDeleted implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class RoleTemplateDeleted implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateDeleted;
  constructor(public payload: { id: number }) {}
}

export class RoleTemplatesOnServerDeleted implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesOnServerDeleted;
  constructor(public payload: { ids: number[] }) {}
}

export class RoleTemplateOnServerActivated implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateOnServerActivated;
  constructor(public payload: { id: number }) {}
}

export class RoleTemplateActivated implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplateActivated;
  constructor(public payload: { id: number }) {}
}

export class RoleTemplatesDeleted implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesDeleted;
  constructor(public payload: { ids: number[] }) {}
}

export class RoleTemplatesPageRequested implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class RoleTemplatesPageLoaded implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesPageLoaded;
  constructor(
    public payload: { roleTemplates: RoleTemplate[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class RoleTemplatesPageCancelled implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesPageCancelled;
}

export class AllRoleTemplatesRequested implements Action {
  readonly type = RoleTemplateActionTypes.AllRoleTemplatesRequested;
}

export class AllRoleTemplatesLoaded implements Action {
  readonly type = RoleTemplateActionTypes.AllRoleTemplatesLoaded;
  constructor(public payload: { roles: RoleTemplate[] }) {}
}

export class RoleTemplatesPageToggleLoading implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class RoleTemplatesActionToggleLoading implements Action {
  readonly type = RoleTemplateActionTypes.RoleTemplatesActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowRoleTemplateError implements Action {
  readonly type = RoleTemplateActionTypes.ThrowRoleTemplateError;

  constructor(public payload: { error: any }) {}
}

export class FireRoleTemplateSuccess implements Action {
  readonly type = RoleTemplateActionTypes.FireRoleTemplateSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type RoleTemplateActions =
  | RoleTemplateCreated
  | RoleTemplateUpdated
  | RoleTemplateDeleted
  | RoleTemplatesDeleted
  | RoleTemplatesPageRequested
  | RoleTemplatesPageLoaded
  | RoleTemplatesPageCancelled
  | AllRoleTemplatesLoaded
  | AllRoleTemplatesRequested
  | RoleTemplateOnServerCreated
  | RoleTemplateOnServerUpdated
  | RoleTemplateOnServerDeleted
  | RoleTemplatesOnServerDeleted
  | RoleTemplatesPageToggleLoading
  | RoleTemplatesActionToggleLoading
  | ThrowRoleTemplateError
  | FireRoleTemplateSuccess;
